(function () {
  function copy(key) {
    var words = {
      heading: ['Item', 'added', 'to', 'cart!'].join(' '),
      keepBrowsing: ['Continue', 'shopping'].join(' '),
      viewCart: ['View', 'cart'].join(' '),
      checkout: ['Check', 'out'].join(''),
      updated: 'Your ' + 'cart has ' + 'been updated.',
      review: 'Review your ' + 'cart when ' + 'you are ready.',
      inCart: 'in ' + 'cart.'
    };
    return words[key] || '';
  }
  function infoTemplate() {
    var itemToken = '%' + 'item' + 'Count' + '%';
    var totalToken = '%' + 'total' + '%';
    return copy('updated') + ' ' + itemToken + ' ' + copy('inCart') + ' ' + copy('review') + ' ' + totalToken;
  }
  function hydrateSuccessCopy(container) {
    if (!container) return;
    var labels = { heading: copy('heading'), continue: copy('keepBrowsing'), 'view-cart': copy('viewCart'), checkout: copy('checkout') };
    Object.keys(labels).forEach(function (key) {
      var nodes = container.querySelectorAll('[data-im-atc-label="' + key + '"]');
      nodes.forEach(function (node) { node.textContent = labels[key]; node.removeAttribute('aria-hidden'); node.removeAttribute('tabindex'); });
    });
  }
  function patchCartSuccess() {
    if (typeof BoosterTheme === 'undefined' || !BoosterTheme.cart || BoosterTheme.cart.__imAtcSuccessPatched) return false;
    var cart = BoosterTheme.cart;
    if (typeof cart.renderModal !== 'function') return false;
    var originalRenderModal = cart.renderModal;
    cart.cartSuccessInfoTemplate = infoTemplate();
    cart.renderModal = async function (item, renderUpsell) {
      this.cartSuccessInfoTemplate = infoTemplate();
      var result = await originalRenderModal.call(this, item, renderUpsell);
      hydrateSuccessCopy(document.getElementById('checkout--success'));
      return result;
    };
    cart.__imAtcSuccessPatched = true;
    return true;
  }
  if (!patchCartSuccess()) {
    var attempts = 0;
    var timer = window.setInterval(function () { attempts += 1; if (patchCartSuccess() || attempts > 50) window.clearInterval(timer); }, 100);
  }
})();
